<template>

<com-item name="hindex.near" :is-cards="true" :size="size" :loading="loading" class="games" title="Near Misses" v-if="data.near.length">

	<template v-slot:about>

		<p>The games that are one play away from your H-index.</p>

	</template>

	<template v-slot:stats>

        <com-card :item="item" v-for="item in data.near" :key="item.g" :id="item.g" :name="$store.getters['data/games/associated'][item.g].name" class="card">

            <core-card-foot-stat :value="item.c" text="play" :plural="true" />

            <core-card-foot-date :value="item.f" text="first play" />

            <core-card-foot-date :value="item.d" text="last play" />

        </com-card>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comCard from './../common/Card'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
        'com-card': comCard
	},

	computed: {

		loading: function() {
		
			return this.fetching
		
		},

		data: function() {

			return this.$store.getters['page/insights/hindex/games']

		},

		active: function() {

			return this.data.near.length && !this.loading

		}

	},

	methods: {

		subtext: function(value) {

			return 'Last played on ' + this.$options.filters.formatDate(value, this.$util.date.format('Do', 'MMMM', 'YYYY'))

		},

		onMoreClick: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsHindexGames'
			})

		}
	
	}

}

</script>

<style scoped>

</style>